// SAB-401: NFL mobile players filter sheet. Mirrors
// mlb-beta/players-mobile/FilterSheet.tsx but only with sections relevant
// to NFL:
//   - Availability (FA / All / Taken) — same as MLB
//   - Time range / Stat view — DROPPED. NFL leaderboard RPC is season-only
//     today; per-game view doesn't have data to back it. If/when NFL adds
//     a window-filter equivalent, copy the MLB pattern back in.
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Seg } from '@/components/ui/seg';

export type OwnershipFilter = 'all' | 'available' | 'taken';

const OWNERSHIP_OPTIONS = [
  { value: 'available', label: 'Available' },
  { value: 'all',       label: 'All' },
  { value: 'taken',     label: 'Taken' },
] as const;

interface FilterSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ownershipFilter: OwnershipFilter;
  onOwnershipChange: (value: OwnershipFilter) => void;
}

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-[10.5px] font-display font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">
      {children}
    </div>
  );
}

export function FilterSheet({
  open, onOpenChange,
  ownershipFilter, onOwnershipChange,
}: FilterSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="rounded-t-2xl pb-[max(env(safe-area-inset-bottom),1rem)]"
      >
        <SheetHeader className="text-left">
          <SheetTitle className="font-display">Filters</SheetTitle>
        </SheetHeader>

        <div className="space-y-4 mt-3">
          <div>
            <SectionLabel>Availability</SectionLabel>
            <Seg
              value={ownershipFilter}
              options={OWNERSHIP_OPTIONS}
              onChange={(v) => onOwnershipChange(v as OwnershipFilter)}
              ariaLabel="Availability filter"
            />
          </div>
        </div>

        <Button onClick={() => onOpenChange(false)} className="w-full mt-5 h-11">
          Done
        </Button>
      </SheetContent>
    </Sheet>
  );
}

export default FilterSheet;
